module.exports = __webpack_public_path__ + "static/media/robertAubrey.8441b0e4.jpg";